import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { BUSINESS, waLink } from "../data/site";
import { Reveal } from "./Reveal";
import LeadForm from "./LeadForm";

export default function Contact() {
  return (
    <section id="contact" className="py-24 sm:py-32 bg-[#1B1B1B]" data-testid="contact-section">
      <div className="container-lux grid lg:grid-cols-2 gap-14">
        <Reveal>
          <p className="overline mb-3">Contact</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight mb-4">
            Let&apos;s talk about <span className="text-gold-metallic">your roof.</span>
          </h2>
          <p className="text-[#C8C8C8] mb-8">Fill in the form and our team will be in touch within one working day. Or reach us directly below.</p>

          <div className="space-y-4">
            <a href={BUSINESS.phoneHref} data-testid="contact-call" className="flex items-center gap-4 glass rounded-sm p-4 hover:border-[#D4AF37]/50 transition-colors">
              <Phone size={20} className="text-[#D4AF37]" strokeWidth={1.5} />
              <div><p className="text-xs uppercase tracking-wider text-[#C8C8C8]">Call</p><p className="font-head text-lg">{BUSINESS.phone}</p></div>
            </a>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-4 glass rounded-sm p-4 hover:border-[#D4AF37]/50 transition-colors">
              <MessageCircle size={20} className="text-[#25D366]" strokeWidth={1.5} />
              <div><p className="text-xs uppercase tracking-wider text-[#C8C8C8]">WhatsApp</p><p className="font-head text-lg">Message Us</p></div>
            </a>
            <a href={`mailto:${BUSINESS.email}`} data-testid="contact-email" className="flex items-center gap-4 glass rounded-sm p-4 hover:border-[#D4AF37]/50 transition-colors">
              <Mail size={20} className="text-[#D4AF37]" strokeWidth={1.5} />
              <div><p className="text-xs uppercase tracking-wider text-[#C8C8C8]">Email</p><p className="font-head text-lg">{BUSINESS.email}</p></div>
            </a>
            <a href="https://www.google.com/maps?q=51+Copperfield+Road,Poynton,SK12+1NQ" target="_blank" rel="noreferrer" data-testid="contact-maps" className="flex items-center gap-4 glass rounded-sm p-4 hover:border-[#D4AF37]/50 transition-colors">
              <MapPin size={20} className="text-[#D4AF37]" strokeWidth={1.5} />
              <div><p className="text-xs uppercase tracking-wider text-[#C8C8C8]">Visit</p><p className="font-head text-lg">{BUSINESS.address.join(", ")}</p></div>
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="glass rounded-md p-6 sm:p-8">
            <h3 className="font-head text-2xl uppercase tracking-tight mb-5">Request A Free Quote</h3>
            <LeadForm source="contact-section" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
